import { Component, OnInit } from '@angular/core';
import { HaloLoaderService } from './halo-loader.service';

@Component({
  selector: 'app-halo-loader',
  templateUrl: './halo-loader.component.html',
  styleUrls: ['./halo-loader.component.scss'],
})
export class HaloLoaderComponent implements OnInit {
  public isLoading: boolean = false;

  constructor(private service: HaloLoaderService) {}

  ngOnInit() {
    this.service.processChange.subscribe((count: number) => {
      setTimeout(() => this.isLoading = !!count);
    });
  }
}
